'use client';

import React from 'react';
import Skeleton from '@mui/material/Skeleton';

import {skeletonLoaderUseStyles} from './loading.styles';

const SkeltonLoader: React.FC = () => {
  const classes = skeletonLoaderUseStyles();
  return (
    <>
      <Skeleton
        data-testid="application-loader"
        variant="text"
        height={200}
        className={classes.centerScreen}
        aria-label="Loading"
        tabIndex={0}
      />
      <Skeleton variant="rectangular" animation="wave" height="75vh" className={classes.centerScreen} />
    </>
  );
};

export default SkeltonLoader;
